/* eslint-disable */
import React from 'react';
// import { useSelector } from 'react-redux';

// components
import { Select } from '../components/inputs';
import { FormRow } from '../components/layout';
// import { Collapse } from '../../../common/components';

function Agent() {
  return (
    <div>
      <FormRow>
        <Select
          name="agent_relationship"
          cols="6"
        />
      </FormRow>
    </div>
  );
}

export default Agent;
